<script lang="ts">
  import type { ArticleItemProps } from '$lib/types/components';
  import { formatImageSrcForStyle } from '$lib/utils/images';
  import { twMerge } from 'tailwind-merge';
  import ArticleInfo from './ArticleInfo.svelte';
  import ContentListitem from './ContentListItem.svelte';

  type $$Props = ArticleItemProps & {
    hideAuthorImage?: boolean;
  };

  export let variant: $$Props['variant'] = 'md';
  export let hideAuthorImage: $$Props['hideAuthorImage'] = false;

  const {
    imgUri,
    imgAlt,
    href,
    authorImage,
    nonLazyImg,
    class: restPropsClass,
    ...infoProps
  } = $$props as $$Props;

  const infoClasses = {
    category: {
      md: 'md:mb-1.5',
      lg: 'md:mb-3'
    },
    metadata: {
      md: 'md:pt-3',
      lg: 'md:pt-4'
    }
  };

  const imgStyleId = variant === 'lg' ? '3_2_576px' : '3_2_320px';

  let imgSrc: string;

  if (imgUri) {
    imgSrc = formatImageSrcForStyle(imgUri, imgStyleId);
  }

  const imgAltText = imgAlt ?? `Image for article: ${infoProps.title}`;
</script>

<ContentListitem class={restPropsClass} {imgSrc} {variant} {nonLazyImg} {href} imgAlt={imgAltText}>
  <ArticleInfo
    {...infoProps}
    {...!hideAuthorImage && { authorImage }}
    headingSize="md"
    categoryClass={twMerge('mb-1', variant && infoClasses.category[variant])}
    metadataClass={twMerge(variant && infoClasses.metadata[variant])}
    hideAuthorImageMobile
  />
</ContentListitem>

<!--
@component
An Article List item displays a summarized view of an article.
## Props
@prop title: string;
@prop authorName: string;
@prop imgSrc: string;
@prop imgAlt: string;
@prop href: string;
@prop category: string = undefined;
@prop description: string = undefined;
@prop revisionDate: string = undefined;
@prop authorImage: string = undefined;
@prop authorImageAlt: string = undefined;
@prop headingTag: string = 'h3';
@prop variant: 'md' | 'lg' = 'md';
-->
